<template lang="html">
  <div class="Chunk">
    <h2 v-if="needsVideoTitle">{{video.title}}</h2>
    <div class="player-container">
      <div class="player">
        <div class="stick-player">
          <iframe id="ytplayer" type="text/html" :width="iframeWidth" height="360"
            :src="'https://www.youtube.com/embed/'
                + video.key
                + '?enablejsapi=1'
                + '&iv_load_policy=3'
                + '&modestbranding=1'
                + '&autoplay=1'

                /* https://developers.google.com/youtube/player_parameters */
                /* + '&version=3'
                + '&loop=1'
                + '&playlist=' + video.key */

                + playerVars
              "
            frameborder="0"></iframe>
          <ChunkBar :width="iframeWidth" :duration="video.duration" :start="chunkComputed.start" :end="chunkComputed.end" />
          <div class="">
            <LoopControls :disabled="chunkComputed.end <= chunkComputed.start" @change="updateLoopState" @rewind="rewind" :loop="loop" :loopForever="loopForever" />
          </div>
        </div>
      </div>
      <ChunkSiblings :chunks="siblings" :current="chunkComputed"/>
    </div>
    <!-- <ChunkSiblingsHorizontal :chunks="siblings" :current="chunkComputed"/> -->
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
// import ChunkSiblingsHorizontal from '@/components/ChunkSiblingsHorizontal'
import ChunkSiblings from '@/components/ChunkSiblings'
import ChunkBar from '@/components/ChunkBar'
import LoopControls from '@/components/LoopControls'
import YouTubePlayer from 'youtube-player';

export default {
  name: 'Chunk',
  props: ['chunkID', 'needsVideoTitle', 'embeded'],
  components: {
    // ChunkSiblingsHorizontal,
    ChunkSiblings,
    ChunkBar,
    LoopControls
  },

  methods: {
    clearPlayerWaiter() {
      // console.log("clearPlayerWaiter", this.chunkComputed.id);
      window.clearTimeout(window.chunkWait);
    },
    pauseWhenTimeComes() {
      // console.log("pauseWhenTimeComes:", this.chunkComputed.id);
      window.player.getCurrentTime().then((currentTime) => {
        return new Promise((resolve) => {
          // console.log(currentTime);
          if (this.chunkComputed.end > this.chunkComputed.start) {
            // console.log("end > start", this.chunkComputed.start, this.chunkComputed.end);
            if (currentTime > this.chunkComputed.end) {
              // console.log(this.chunkComputed);
              // console.log("CT > end");
              // console.log("Time come");
              resolve(true)
            } else {
              resolve(false)
            }
          } else {
            resolve(false)
          }
        })
      })
      .then((timeCome) => {
        return new Promise((resolve) => {
          if (timeCome) {
            if (this.loop) {
              if (this.loopForever) {
                this.rewind()
                // this.play()
              } else {
                this.pause()
                this.rewind()
              }
            }
          }
          resolve()
        })
      }).then(()=> {
        if (window.chunkWait) {
          this.clearPlayerWaiter()
        }
        window.chunkWait = window.setTimeout(() => {
          // console.log("CKECK AGAIN");
          this.pauseWhenTimeComes()
        }, 500)
      })
    },

    play() {
      // console.log("play", this.chunkComputed.id);
      window.player.playVideo();
    },
    pause() {
      window.player.pauseVideo();
    },
    rewind() {
      // console.log("Rewind", this.chunkComputed.id);
      this.seekTo(this.chunkComputed.start)
    },
    stayAtTheEnd() {
      // console.log("Stay at the end");
      this.seekTo(this.chunkComputed.end)
    },
    seekTo(targetTime) {
      // console.log("Seek to:", targetTime);
      window.player.seekTo(targetTime)
    },
    updateLoopState(newValue){
      // console.log("updateLoopState", newValue, this.chunkComputed.id);
      this.loop = newValue.loop
      this.loopForever = newValue.loopForever
    },
  }, // End of Methods

  // LIFECYCLE
  // WHEN MOUNTED init player and play time watcher

  // WHEN UPDATED set head to new start time
  // start playback

  // длина бара и таймлайна не совпадают, таймлайн короче
  mounted() {
    // console.log(":: mounted:");
    // console.log(this.chunkComputed);
    // console.log(window.player);
    window.player = YouTubePlayer('ytplayer', {
      autoplay: true,
    });
    window.player.on('onApiChange', () => {
      // console.log("API changed");
    });
    window.player.on('stateChange', (e) => {
      // console.log('stateChange:', e);
      if (e.data == window.YT.PlayerState.PLAYING) {
        // this.pauseWhenTimeComes();
      }
    });
    window.player.on('ready', () => {
        // console.log('ready:');
        this.seekTo(this.chunkComputed.start)
        this.pauseWhenTimeComes()
        // window.player.getDuration().then(d => console.log("duration:", d));
    });
  },
  beforeUpdate() {
    // console.log(":: before update");
  },
  updated() {
    // console.log(":: updated");
    // console.log(this.chunkComputed);
    this.seekTo(this.chunkComputed.start)
    this.play()
    // console.log("ends at:", Math.floor(this.chunkComputed.end/60) + ":" + this.chunkComputed.end%60);
  },

  // Data
  data: function() {
    return {
      iframeWidth: 640,
      loop: true,
      loopForever: true
    }
  },

  // Computed Properties
  computed: {
    ...mapGetters([
      'chunkByID',
      'videoByID',
      'chunksFromThisVideo',
      'chunksFromOtherVideos',
    ]),
    chunkComputed() {
      // console.log("===");
      // console.log(this.chunkID);
      let chunk = this.chunkByID(this.chunkID);
      // console.log(chunk);
      if (this.embeded) {
        chunk = this.chunkByID(this.chunkID);
      } else {
        chunk = this.chunkByID(this.chunkID);
      }
      // console.log(chunk);
      // console.log("^^^");
      return chunk
    },
    playerOptions() {
      let params = {
        loop: this.loop, // play only chunk
      }
      return params
    },
    siblings() {
      return this.chunksFromThisVideo(this.chunkComputed.video)
    },
    chunkParams(){
      let params = {
        end: this.chunkComputed.end,
        start: this.chunkComputed.start,
        shouldPause: this.chunkComputed.end > this.chunkComputed.start,
      }
      return params
    },
    video(){
      return this.videoByID(this.chunkComputed.video)
    },
    playerVars() {
      return ""
             + `&origin=${this.$origin}`
             + `&widget_referrer=${this.$origin}`
        // + `&start=${this.chunkComputed.start}`
    },
  }
}
</script>

<style lang="css" scoped>
.Chunk {
  margin: 0 -3rem 2rem;
  background-color: rgb(12, 18, 23);
  padding: 2rem 3rem;
}

.player-container {
  display: flex;
  justify-content: center;
}
.stick-player {
  position: sticky;
  top: 3rem;
}

iframe {
  display: block;
  margin: auto;
}
</style>
